import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { View, StyleSheet, Image } from 'react-native';
import Logo from '../../assets/images/logo/logo-berry@2x.png';
import Button from '../UI/Button';
import { isRowLayout } from '../../utilities/screen';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 10,
    justifyContent: 'space-between',
    width: '100%',
  },
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

function Header() {
  const history = useHistory();
  return (
    <View style={styles.container}>
      <Link to="/">
        <Image source={Logo} style={{ width: 100, height: 40 }} />
      </Link>
      <View style={styles.buttonContainer}>
        <Button
          text={'Anmelden'}
          action={() => history.push('/login')}
          size="medium"
          type="secondary"
          style={{ marginRight: 10 }}
        />
        <Button
          text={isRowLayout ? 'Treffen anbieten' : 'Anbieten'}
          action={() => history.push('/register')}
          size="medium"
        />
      </View>
    </View>
  );
}

export default Header;
